import React, { useEffect, useState } from "react";

export default function UtilityPattern({ cue }) {
	return (
		<div className="w-screen h-screen">
			{cue.pattern === "p1" && <P1 />}
			{cue.pattern === "p2" && <P2 />}
			{cue.pattern === "p3" && <P3 />}
		</div>
	);
}

// Custom colour bars
const P1 = () => {
	return (
		<div className="w-screen h-screen bg-black overflow-hidden">
			{/* top */}
			<div style={{ height: "80%" }} className="flex">
				<div className="h-full w-full bg-gray-100"></div>
				<div className="h-full w-full bg-gray-400"></div>
				<div className="h-full w-full bg-green-600"></div>
				<div className="h-full w-full bg-purple-600"></div>
				<div className="h-full w-full bg-red-600"></div>
				<div className="h-full w-full bg-main-800"></div>
				<div className="h-full w-full bg-black"></div>
			</div>
			{/* bottom */}
			<div style={{ height: "20%" }} className="flex">
				<div className="h-full w-full bg-black"></div>
				<div className="h-full w-full bg-gray-800"></div>
				<div className="h-full w-full bg-gray-700"></div>
				<div className="h-full w-full bg-gray-600"></div>
				<div className="h-full w-full bg-gray-500"></div>
				<div className="h-full w-full bg-gray-400"></div>
				<div className="h-full w-full bg-gray-300"></div>
				{/* <div className="h-full w-full bg-gray-200"></div> */}
				<div className="h-full w-full bg-gray-100"></div>
			</div>
		</div>
	);
};

// Grid with screen dimensions
const P2 = () => {
	const wind = typeof window !== "undefined" && window;
	const [time, setTime] = useState("00:00:00:000");
	const [int, setInt] = useState(null);

	const [dimensions, setDimensions] = useState({
		height: wind?.outerHeight,
		width: wind?.outerWidth,
	});

	const startTimer = () => {
		setInt(
			setInterval(() => {
				let t = new Date();
				let hours = `${t.getHours()}`;
				let mins = `${t.getMinutes()}`;
				let seconds = `${t.getSeconds()}`;
				let ms = `${t.getMilliseconds()}`;

				setTime(
					`${hours}:${mins > 9 ? mins : `0${mins}`}:${
						seconds > 9 ? seconds : `0${seconds}`
					}:${ms < 100 ? `${ms < 10 ? "0" : ""}0${ms}` : ms}`
				);
			}, [50])
		);
	};

	useEffect(() => {
		startTimer();

		return () => {
			clearInterval(int);
		};
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setDimensions({
				height: wind?.outerHeight,
				width: wind?.outerWidth,
			});
		};

		wind.addEventListener("resize", handleResize);
		return () => {
			wind.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<div className="w-screen h-screen bg-black overflow-hidden">
			<div className="relative grid grid-cols-5 sm:grid-cols-7 md:grid-cols-9 lg:grid-cols-12">
				{/* Center marker */}
				<div className="absolute flex items-center justify-center inset-0 w-screen h-screen font-bold">
					<span className="px-10 sm:px-20 py-2 sm:py-4 bg-gray-100 text-center text-gray-900 font-mono flex flex-col">
						<span className=" text-xl md:text-5xl lg:text-6xl ">{time}</span>
						<span className=" text-sm md:text-xl lg:text-2xl">
							{dimensions.width}px x {dimensions.height}px
						</span>
					</span>
				</div>

				{/* top left */}
				<div
					className="border-l-2 border-t-2 absolute w-20 h-16"
					style={{
						top: 8,
						left: 8,
					}}
				></div>
				{/* top right */}
				<div
					className="border-r-2 border-t-2 absolute w-20 h-16"
					style={{
						top: 8,
						right: 8,
					}}
				></div>
				{/* bottom left */}
				<div
					className="border-l-2 border-b-2 fixed w-20 h-16"
					style={{
						bottom: 12,
						left: 18,
					}}
				></div>
				{/* bottom right */}
				<div
					className="border-r-2 border-b-2 fixed w-20 h-16"
					style={{
						bottom: 12,
						right: 18,
					}}
				></div>

				{Array.from(Array(300).keys()).map((num) => {
					return (
						<div
							key={num}
							className="h-16 w-auto bg-gray-800 border-2 border-gray-700"
						></div>
					);
				})}
			</div>
		</div>
	);
};

// EBU 75%
const P3 = () => {
	return (
		<div className="w-screen h-screen bg-black overflow-hidden">
			{/* top */}
			<div style={{ height: "100%" }} className="flex">
				<div
					style={{
						backgroundColor: "white",
					}}
					className="h-full w-full "
				></div>
				<div
					style={{
						backgroundColor: "#bbbbbb",
					}}
					className="h-full w-full "
				></div>
				<div
					style={{
						backgroundColor: "#bdbd12",
					}}
					className="h-full w-full "
				></div>
				<div
					style={{
						backgroundColor: "#00bcbc",
					}}
					className="h-full w-full "
				></div>
				<div
					style={{
						backgroundColor: "#00bd12",
					}}
					className="h-full w-full "
				></div>
				<div
					style={{
						backgroundColor: "#c000bc",
					}}
					className="h-full w-full "
				></div>
				<div
					style={{
						backgroundColor: "#c00000",
					}}
					className="h-full w-full "
				></div>
				<div
					style={{
						backgroundColor: "#0000bb",
					}}
					className="h-full w-full "
				></div>
				<div
					style={{
						backgroundColor: "black",
					}}
					className="h-full w-full "
				></div>
			</div>
		</div>
	);
};
